import Api from '../Api';

export const getUnits = () => async dispatch => {
  const { data } = await Api.get('/dropdowns/units');
  dispatch({
    type: 'FETCH_UNITS',
    payload: data,
  });
};

export const clearUnits = () => {
  return {
    type: 'CLEAR_UNITS',
  };
};

export const getUnit = id => async dispatch => {
  const { data } = await Api.get(`/dropdowns/units/${id}`);
  dispatch({
    type: 'FETCH_UNIT',
    payload: data,
  });
};

export const clearUnit = () => {
  return {
    type: 'CLEAR_UNIT',
  };
};

export const getUnitIds = () => async dispatch => {
  const { data } = await Api.get('/dropdowns/units/ids');
  dispatch({
    type: 'FETCH_UNIT_IDS',
    payload: data,
  });
};

export const clearUnitIds = () => {
  return {
    type: 'CLEAR_UNIT_IDS',
  };
};
